import columns from '../../../../../react-table/helpers/columns';
import { sumRoundedTotal } from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    DateTimeColumn,
    NumberColumn,
    TextColumn,
    DurationColumn,
    PercentageColumn,
    FloatColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'Predes',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchS8Id').withWidth(210)),
        new TextColumn('Category', 'mailCategory'),
        new TextColumn('Class', 'mailSubClass'),
        new DateTimeColumn('Close date', 'despatchClosedDate'),
        new TextColumn('Day', 'despatchClosedDayOfWeek'),
        new NumberColumn('Legs', 'legCount'),
        new TextColumn('First leg conveyance reference', 'firstLegName'),
        new DateTimeColumn('First leg planned departure', 'firstLegScheduledDepartureLocalDateTime'),
        new TextColumn('Last leg conveyance reference', 'lastLegName'),
        new DateTimeColumn('Last leg planned arrival', 'lastLegScheduledArrivalLocalDateTime'),
      ],
    },
    {
      Header: 'Targets',
      columns: [
        new DateTimeColumn('LAT', 'lastArrivalDateTime'),
        new DateTimeColumn('CST', 'criticalScanDateTime'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new DateTimeColumn('First scan', 'resdesFirstScanDateTime'),
        new DateTimeColumn('Last scan', 'resdesLastScanDateTime'),
        new DurationColumn('Tail', 'resdesTail'),
      ],
    },
    {
      Header: 'Receptacles counts',
      columns: [
        new NumberColumn('PREDES', 'predesCount')
          .withTotalHeader(sumRoundedTotal),
        new NumberColumn('RESDES', 'resdesCount')
          .withTotalHeader(sumRoundedTotal),
        new NumberColumn('<= CST', 'resdesCapturedBeforeOrEqualToCSTCount')
          .withTotalHeader(sumRoundedTotal),
        new PercentageColumn('% <= CST', 'onTimeCSTPercentage'),
      ],
    },
    {
      Header: 'Receptacles gross weight',
      columns: [
        new FloatColumn('PREDES', 'totalPredesGrossWeight')
          .withTotalHeader(sumRoundedTotal),
        new FloatColumn('RESDES', 'totalResdesGrossWeight')
          .withTotalHeader(sumRoundedTotal),
        new FloatColumn('<= CST', 'resdesCapturedBeforeOrEqualToCSTGrossWeight')
          .withTotalHeader(sumRoundedTotal),
        new FloatColumn('> CST', 'resdesCapturedAfterCSTGrossWeight')
          .withTotalHeader(sumRoundedTotal),
      ],
    },
    {
      Header: 'Receptacles net weight',
      columns: [
        new FloatColumn('PREDES', 'totalPredesNetWeight')
          .withTotalHeader(sumRoundedTotal),
        new FloatColumn('RESDES', 'totalResdesNetWeight')
          .withTotalHeader(sumRoundedTotal),
        new FloatColumn('<= CST', 'resdesCapturedBeforeOrEqualToCSTNetWeight')
          .withTotalHeader(sumRoundedTotal),
        new FloatColumn('> CST', 'resdesCapturedAfterCSTNetWeight')
          .withTotalHeader(sumRoundedTotal),
      ],
    },
  ];
};
